export default __webpack_public_path__ + "static/media/SecPlusCert.cdfc6725.pdf";